import { z } from "zod";
import apiRepresentation3dSchema from "./apiRepresentation3dSchema";
import { vector2dSchema, vector3dSchema } from "../primitivesSchema";
import apiPlacementSchema from "../placementSchema";

const holeProfilesSchema = z.array(
    z.array(vector3dSchema) // Each element is an array of vectors
  );

const apiExtrudedAreaSolidSchema = apiRepresentation3dSchema.extend({
    outerProfile: z.array(z.lazy(() => vector2dSchema)),
    voids: holeProfilesSchema,
    placement: apiPlacementSchema,
    extrudedDirection: vector3dSchema,
    depth: z.number()

  });

export default apiExtrudedAreaSolidSchema;